var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgArrowLeft = function SvgArrowLeft(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "25px",
    viewBox: "0 0 16 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "318BA41C-B4FC-4390-A515-14666DDB192C") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "DS_Suez_PCE_Atoms",
    transform: "translate(-130.000000, -542.000000)",
    fill: "#030F40"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Assets-/-Icons-/-Bold-/-Arrow-/-arrow-left-1",
    transform: "translate(130.000000, 542.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.499998235,12 C0.499181025,11.3382977 0.783391099,10.7082987 1.28,10.271 L12.432,0.46 C13.200591,-0.184929277 14.3434732,-0.0983289982 15.0061094,0.655049482 C15.6687456,1.40842796 15.6087582,2.55301564 14.871,3.233 L5.119,11.812 C5.06484525,11.8594692 5.03379078,11.9279857 5.03379078,12 C5.03379078,12.0720143 5.06484525,12.1405308 5.119,12.188 L14.871,20.767 C15.3843369,21.1977441 15.6241001,21.872739 15.497511,22.5307895 C15.3709219,23.18884 14.8978411,23.7267052 14.2613312,23.9362535 C13.6248213,24.1458017 12.9247439,23.9941571 12.432,23.54 L1.284,13.732 C0.786188972,13.2939525 0.500629665,12.6630996 0.499998235,12 Z",
    id: "icon-fill-color"
  }))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgArrowLeft);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/arrow-left.ce727065dcfa516dc6585b4142b0d555.svg";